import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=10f79ef6&scoped=true&"
import script from "./SettingsPanel.vue?vue&type=script&lang=js&"
export * from "./SettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&id=10f79ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f79ef6",
  null
  
)

export default component.exports